export default __webpack_public_path__ + "media/color/miota-a09ea64a.svg";